// Token packs for the Token Bank — base prices in PHP.
export const TOKEN_PACKS = [
  {
    id: "starter",
    name_key: "pack_starter",
    tokens: 1_000_000,
    label: "1M tokens",
    price_php: 1900,
    badge: null,
    bullets: [
      { fr: "Idéal pour découvrir", en: "Perfect to discover" },
      { fr: "1 agent actif", en: "1 active agent" },
      { fr: "Support standard", en: "Standard support" },
    ],
    accent: "#00cfff",
  },
  {
    id: "growth",
    name_key: "pack_growth",
    tokens: 10_000_000,
    label: "10M tokens",
    price_php: 14900,
    badge: { fr: "Le plus populaire", en: "Most popular" },
    bullets: [
      { fr: "3 à 5 agents actifs", en: "3 to 5 active agents" },
      { fr: "Tableau de bord premium", en: "Premium dashboard" },
      { fr: "Support prioritaire", en: "Priority support" },
    ],
    accent: "#deff9a",
  },
  {
    id: "empire",
    name_key: "pack_empire",
    tokens: 100_000_000,
    label: "100M tokens",
    price_php: 119000,
    badge: { fr: "Empire", en: "Empire" },
    bullets: [
      { fr: "Escouade complète (9 agents)", en: "Full squad (9 agents)" },
      { fr: "Cockpit dédié", en: "Dedicated cockpit" },
      { fr: "Accompagnement fondateur", en: "Founder concierge" },
    ],
    accent: "#a78bfa",
  },
];
